import { DoubleLeftOutlined } from '@ant-design/icons';
import { useMemo } from 'react';
import { useSelector } from 'store';
import { NavItemType } from 'types/menu';

const icons = {
  DoubleLeftOutlined
};

// ==============================|| MENU ITEMS - NAV HISTORY ||============================== //

export default function useGetBreadCrumbNav() {
  const { breadCrumbs } = useSelector((state) => state.ui);
  const filteredBreadCrumbs = useMemo(() => {
    return breadCrumbs.filter((crumb) => crumb.type !== 'home');
  }, [breadCrumbs]);

  const breadCrumbNav: NavItemType = useMemo(() => {
    const crumbItems: NavItemType[] = filteredBreadCrumbs.map((crumb, index) => {
      return {
        id: String(index),
        title: crumb.name,
        dataId: crumb.id || null,
        dataCategory: crumb.type,
        type: 'item',
        url: crumb.fullPath || ''
      };
    });

    let crumbNav: NavItemType = {
      id: 'breadCrumbNav',
      title: 'Navigation',
      icon: icons.DoubleLeftOutlined,
      type: 'group',
      children: []
    };

    if (crumbItems.length > 0) {
      crumbNav.children = [
        {
          id: 'history',
          title: 'History',
          type: 'collapse',
          icon: icons.DoubleLeftOutlined,
          children: crumbItems.reverse()
        }
      ];
    }

    return crumbNav;
  }, [filteredBreadCrumbs]);

  return breadCrumbNav;
}
